import B from './button';

const Button = B;

export default Button;
